export default __webpack_public_path__ + "static/media/gallery_02.23b80ee9.jpg";